import { createMetricsFactory } from 'metrics-js';
export const RouterMetrics = createMetricsFactory('crm-records-router-metrics');